const getQrCodeDownloadFileName = (title) => `${title}-ShareCode.png`;

export default getQrCodeDownloadFileName;
